"use strict";
/**
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _slicedToArray = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _createClass = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _classCallCheck = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _wrapNativeSuper = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GoogleErrorDecoder = exports.GoogleError = void 0;

var status_1 = require("./status");

var protobuf = require("protobufjs");

var GoogleError =
/*#__PURE__*/
function (_Error) {
  _inherits(GoogleError, _Error);

  function GoogleError() {
    _classCallCheck(this, GoogleError);

    return _possibleConstructorReturn(this, _getPrototypeOf(GoogleError).apply(this, arguments));
  }

  return GoogleError;
}(_wrapNativeSuper(Error));

exports.GoogleError = GoogleError;

var GoogleErrorDecoder =
/*#__PURE__*/
function () {
  function GoogleErrorDecoder() {
    _classCallCheck(this, GoogleErrorDecoder);

    // eslint-disable-next-line @typescript-eslint/no-var-requires
    var errorProtoJson = require('../../protos/status.json');

    this.root = protobuf.Root.fromJSON(errorProtoJson);
    this.anyType = this.root.lookupType('google.protobuf.Any');
    this.statusType = this.root.lookupType('google.rpc.Status');
    this.errorInfoType = this.root.lookupType('google.rpc.ErrorInfo');
  }

  _createClass(GoogleErrorDecoder, [{
    key: "decodeProtobufAny",
    value: function decodeProtobufAny(anyValue) {
      var match = anyValue.type_url.match(/^type.googleapis.com\/(.*)/);

      if (!match) {
        throw new Error("Unknown type encoded in google.protobuf.any: ".concat(anyValue.type_url));
      }

      var typeName = match[1];
      var type = this.root.lookupType(typeName);

      if (!type) {
        throw new Error("Cannot lookup type ".concat(typeName));
      }

      return type.decode(anyValue.value);
    } // Decodes gRPC-fallback error which is an instance of google.rpc.Status.

  }, {
    key: "decodeRpcStatus",
    value: function decodeRpcStatus(buffer) {
      var uint8array = new Uint8Array(buffer);
      var status = this.statusType.decode(uint8array); // google.rpc.Status contains an array of google.protobuf.Any
      // which need a special treatment

      var details = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = status.details[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var detail = _step.value;

          try {
            var decodedDetail = this.decodeProtobufAny(detail);
            details.push(decodedDetail);
          } catch (err) {// cannot decode detail, likely because of the unknown type - just skip it
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var result = {
        code: status.code,
        message: status.message,
        details: details
      };
      return result;
    } // Construct an Error from a StatusObject.
    // Adapted from https://github.com/grpc/grpc-node/blob/main/packages/grpc-js/src/call.ts#L79

  }, {
    key: "callErrorFromStatus",
    value: function callErrorFromStatus(status) {
      status.message = "".concat(status.code, " ").concat(status_1.Status[status.code], ": ").concat(status.message);
      return Object.assign(new Error(status.message), status);
    } // Decodes gRPC-fallback error which is an instance of google.rpc.Status,
    // and puts it into the object similar to gRPC ServiceError object.

  }, {
    key: "decodeErrorFromBuffer",
    value: function decodeErrorFromBuffer(buffer) {
      return this.callErrorFromStatus(this.decodeRpcStatus(buffer));
    } // Decodes gRPC-fallback error which is an instance of google.rpc.Status.

  }, {
    key: "decodeRpcStatusDetails",
    value: function decodeRpcStatusDetails(bufferArr) {
      var _this = this;

      var status = [];
      bufferArr.forEach(function (buffer) {
        var uint8array = new Uint8Array(buffer);

        var error_status = _this.statusType.decode(uint8array);

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = error_status.details[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var detail = _step2.value;

            try {
              status.push(_this.decodeProtobufAny(detail));
            } catch (err) {// cannot decode detail, likely because of the unknown type - just skip it
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      });
      return status;
    }
  }, {
    key: "decodeMetadata",
    value: function decodeMetadata(err) {
      if (!err.metadata) {
        return err;
      }

      if (err.metadata.get('grpc-status-details-bin')) {
        err.statusDetails = this.decodeRpcStatusDetails(err.metadata.get('grpc-status-details-bin'));
      } // Promote the ErrorInfo fields as first-class of error


      if (err.metadata.get('google.rpc.errorinfo-bin')) {
        var buffer = err.metadata.get('google.rpc.errorinfo-bin');

        if (buffer.length > 1) {
          throw new GoogleError("Multiple ErrorInfo type encoded in err.metadata.get('google.rpc.errorinfo-bin'): ".concat(err.metadata.get('google.rpc.errorinfo-bin')));
        }

        var uint8array = new Uint8Array(buffer[0]);
        var errorInfo = this.errorInfoType.decode(uint8array);

        if (errorInfo.reason) {
          err.reason = errorInfo.reason;
        }

        if (errorInfo.domain) {
          err.domain = errorInfo.domain;
        }

        if (errorInfo.metadata) {
          for (var _i = 0, _Object$entries = Object.entries(errorInfo.metadata); _i < _Object$entries.length; _i++) {
            var _ref3 = _Object$entries[_i];

            var _ref2 = _slicedToArray(_ref3, 2);

            var key = _ref2[0];
            var value = _ref2[1];
            err.metadata.set(key, value);
          }
        }
      }

      return err;
    }
  }]);

  return GoogleErrorDecoder;
}();

exports.GoogleErrorDecoder = GoogleErrorDecoder;